export const namespace = 'auth';
